import { Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { KC_SEARCH_PATH, getPopularTopics } from '../repository';
import { KC_COLORS } from '../theme';

export function PopularTopics() {
  const popularTopics = getPopularTopics();

  return (
    <Box className="kc-topics w-full bg-white py-8 md:py-10">
      <Container maxWidth="lg">
        <div className="text-center mb-5 md:mb-6">
          <h2 className="kc-section-title kc-type-h3 uppercase tracking-[0.08em]">
            Popular Topics
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5">
          {popularTopics.map((topic) => (
            <Link
              key={topic.id}
              to={`${KC_SEARCH_PATH}?q=${encodeURIComponent(topic.query)}`}
              className="kc-topic-pill inline-flex items-center rounded-full px-4 py-2 kc-type-body font-medium transition-all duration-300 ease-out hover:-translate-y-0.5"
              style={{
                border: `1px solid ${KC_COLORS.border}`,
                backgroundColor: KC_COLORS.lightGrey,
                color: KC_COLORS.primaryNavy,
              }}
            >
              {topic.label}
            </Link>
          ))}
        </div>
      </Container>
    </Box>
  );
}
